import { Modal } from '@/components/atoms'
import { ModalTableContent } from '@/components/molecules'
import { usePrerequisiteTarget } from '@/hooks/usePrerequisiteTarget'
import { setPrerequisiteTarget } from '@/store/slices/salesTargetSlice'
import { SELECTION_TYPE } from '@/utils/constants/commonConstants'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

const PrerequisiteTarget = ({openTarget, setOpenTarget, setFormData}) => {
  const [rowSelection, setRowSelection] = useState({})
  const [selectedRowData, setSelectedRowData] = useState([])
  const dispatch = useDispatch()

  const isCloseModal = () => {
    setOpenTarget(!openTarget)
    setRowSelection({})
  }
  const handlePrerequisite = () => {
    setFormData(prev => ({...prev, ...{preRequisiteTarget: selectedRowData?.[0]?.Name}}))
    dispatch(setPrerequisiteTarget(selectedRowData?.[0]?.Name))
    setOpenTarget(!openTarget)
  }

  const columns = [
    {columnKey: 'Name', header: 'Name'},
    {columnKey: 'Description', header: 'Description'},
    {columnKey: 'ModifiedDate', header: 'Modified Date'},
  ]
  const {prerequisiteTargetData} = usePrerequisiteTarget()
  return (
    <Modal
      isDark={true}
      onCloseModal={isCloseModal}
      className="prerequisite-target-modal"
      onClickSecondaryButton={isCloseModal}
      onClickPrimaryButton={handlePrerequisite}
      showSecondaryButton={true}
      showModal={openTarget}
      title="Choose Prerequisite Target"
      text="Please select only one sales target as prerequisite."
      primaryButtonText={'Done'}
      primaryButtonDisabled={Object.keys(rowSelection)?.length === 1 ? false : true}
      content={
        <ModalTableContent
          data={{items: prerequisiteTargetData}}
          columns={columns}
          tableHeader={'Active Targets'}
          size="small"
          isDark={true}
          rowSelection={rowSelection}
          selection={SELECTION_TYPE.MULTIPLE}
          setRowSelection={setRowSelection}
          setSelectedRowData={setSelectedRowData}
          showColumnFilters={false}
        />
      }
      type={MODAL_TYPE.MEDIUM}
    />
  )
}

export default PrerequisiteTarget
